const ProblemSection = () => {
  const points = [
    "Your best clients came from relationships, not cold emails",
    "Your team's time is worth more than chasing leads", 
    "Generic outreach doesn't attract the clients you want"
  ];

  return (
    <section
      id="problem"
      data-testid="problem-section"
      className="py-20 md:py-32 px-5 md:px-12 lg:px-20 bg-black border-t border-white/5"
    >
      <div className="max-w-6xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-20">
          <div>
            <p className="text-[#6DBE2E] text-[11px] md:text-xs font-medium tracking-[0.2em] uppercase mb-4 md:mb-6">
              The Problem
            </p>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-medium text-white leading-tight tracking-tight">
              Most outbound doesn't work for you.
            </h2>
          </div>

          <div className="lg:pt-4">
            <p className="text-white/50 text-base md:text-lg leading-relaxed mb-6">
              You've seen how other companies do outbound. Spray-and-pray emails. Generic templates. 
              Aggressive follow-ups that make you cringe.
            </p>
            <p className="text-white/50 text-base md:text-lg leading-relaxed mb-8">
              That approach might work for some. But when reputation is everything, 
              you need something different.
            </p>

            <div className="space-y-3">
              {points.map((point, i) => (
                <div key={i} className="flex items-start gap-3">
                  <span className="text-[#6DBE2E] text-lg mt-0.5 flex-shrink-0">→</span>
                  <p className="text-white/70 text-sm md:text-base">{point}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProblemSection;
